import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/settings/notification-and-response/')({
  beforeLoad() {
    throw redirect({
      to: '/settings/notification-and-response/notification-rules'
    });
  }
});